import Layout from "../../layouts";
import Content from "../../layouts/content";
import AuthContainer from "../../containers/create-company";
import SEO from "../../components/seo";

export const CreateCompany = () => {
    return (
        <Layout>
            <SEO />
            <Content fullHeight>
                <AuthContainer />
            </Content>
        </Layout>
    );
};
